<template>
  <div class="container">
    <a-modal
      class="gufiiguy"
      title="添加其他危害因素"
      :visible="addOtherVisible"
      @cancel="closeAddPost"
      width="70%"
      @ok="addPost"
    >
      <div class="top">
        <a-input
          style="width: 200px; margin-right: 10px"
          v-model="factorName"
          allowClear
          placeholder="危害因素名称"
          @keyup.enter.native="serch"
        />
        <a-button type="primary" @click="serch"> 查询 </a-button>
      </div>
      <div class="bottom">
        <div class="center">
          <a-table
            :pagination="false"
            :row-selection="{ selectedRowKeys: selectedRowKeys[pagination.current], onChange: onSelectChange }"
            :columns="columns"
            :data-source="factorList"
          >
            <span slot="index" slot-scope="text, record, index">
              {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
            </span>
          </a-table>
        </div>
        <div class="bottom">
          <a-pagination
            show-size-changer
            show-quick-jumper
            v-model="pagination.current"
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
            @showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30', '40', '50']"
            @change="onShowSizeChange"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getOtherFactor } from '@/api/Industry'
export default {
  data() {
    return {
      dataList: [],
      industryList: {
        1: [],
      },
      rowData: '',
      pagination: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      factorList: [],
      factorName: '',
      selectedRowKeys: {
        1: [],
      },
      addOtherVisible: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: {
            customRender: 'index',
          },
        },
        {
          title: '危害因素名称',
          dataIndex: 'factorName',
        },
        {
          title: '检测标准',
          dataIndex: 'standardInfo',
        },
        {
          title: '限制',
          dataIndex: 'price',
        },
        {
          title: '单价',
          dataIndex: 'price',
        },
      ],
    }
  },
  methods: {
    //查询
    serch() {
      console.log('11111111111111111111111111111')
      this.pagination.current = 1
      this.getList(this.rowData)
    },
    //分页
    onShowSizeChange(current, pageSize) {
      console.log(current, pageSize)
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      //改变完 重新渲染数据
      this.getList(this.rowData)
    },
    //获取列表数据
    getList(data) {
      getOtherFactor({
        postId: data.postId,
        sheetId: data.sheetId,
        subId: data.subId,
        factorName: this.factorName,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          this.factorList = res.data
          this.pagination.totalCount = res.total
        }
      })
    },
    init(data) {
      this.rowData = data
      this.$nextTick(() => {
        this.getList(data)
        this.addOtherVisible = true
      })
    },
    //关闭弹窗
    closeAddPost() {
      this.addOtherVisible = false
    },
    //提交弹窗
    addPost() {
      for (var i in this.industryList) {
        this.industryList[i].forEach((item) => {
          this.dataList.push(item)
        })
      }
      this.$emit('addOtherIndustry', this.dataList)
      this.addOtherVisible = false
    },
    //添加危害因素
    onSelectChange(selectedRowKeys, val) {
      console.log(selectedRowKeys, val, 'selectedRowKeys, val')
      //  this.selectedRowKeys = selectedRowKeys
      this.selectedRowKeys[this.pagination.current] = selectedRowKeys
      this.industryList[this.pagination.current] = val
      this.getList(this.rowData)
    },
  },
}
</script>

<style scoped>
.container {
  padding: 10px;
}
.top {
  padding: 20px;
}

.bottom {
  padding: 10px;
}
</style>